import React from 'react';

/**
 * 合并多个内敛样式，多个内敛样式的优先级按顺序递增
 * @param styles 内敛样式
 */
export const getComposedStyle = (...styles: (React.CSSProperties | undefined)[]): React.CSSProperties => {
  if (!Array.isArray(styles) || !styles.length) return {};
  const composedStyle = {};
  for (const style of styles) {
    if (!style) continue;
    Object.assign(composedStyle, style);
  }
  return composedStyle;
};
